export default "__VITE_ASSET__AUzOXgfi__"